import { useEffect, useState } from 'react'
import EkomApi from '../api/EkomApi'
import { useCheckedContext } from '../context/CheckedContext'
import { useTableContextParams } from '../context/TableContext'
import { iMsg } from '../types/msg.types'

export const useMsgsList = (isSent: boolean, extSystemId?: string, extObjectId?: string, relatedId?: string) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [data, setData] = useState<iMsg[]>([])
  const [totalCount, setTotalCount] = useState<number>()
  const params = useTableContextParams()
  const { resetChecked, reloadIndex } = useCheckedContext()

  useEffect(() => {
    fetchData()
  }, [params, reloadIndex])

  const fetchData = async () => {
    resetChecked()
    setError('')
    setLoading(true)
    try {
      if (extSystemId) {
        params.systemExtId = extSystemId
      }
      if (extObjectId) {
        params.objectExtId = extObjectId
      }
      if (relatedId) {
        if (isSent) {
          params.incomingMessage = relatedId
        } else {
          params.outgoingMessage = relatedId
        }
      }

      const result = isSent ? await EkomApi.getMsgOutgoingSearch(params) : await EkomApi.getMsgIncomingSearch(params)
      const msgs = result.data.map((msg) => ({
        ...msg.message,
        attachmentCount: msg.attachmentCount,
        readsCount: msg.readsCount
      }))
      setData(msgs)
      setTotalCount(result.totalCount)
    } catch (error: any) {
      setError('Nepodařilo se získat data.')
    } finally {
      setLoading(false)
    }
  }

  return { loading, error, data, totalCount }
}
